/**
 * Feel Awsm · Electrolyt Essenz Funnel
 * Add-to-cart mirrors assets/product-form.js (Dawn pattern):
 *   - sections in POST body (for fetch; XHR for selling plans)
 *   - cart.setActiveElement + cart.renderContents + fallback section_id fetch
 * + scroll reveal + FAQ + nav + sticky cart
 */
(function () {
  "use strict";

  // ============ SCROLL REVEAL ============
  const revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add("in");
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });

  document.querySelectorAll(".eef-reveal").forEach(function (el) { revealObserver.observe(el); });

  // ============ FAQ ACCORDION ============
  document.querySelectorAll(".eef-faq-item").forEach(function (item) {
    item.addEventListener("toggle", function () {
      item.classList.toggle("eef-open", item.open);
    });
  });

  // ============ PRICING TOGGLE ============
  var toggles = document.querySelectorAll(".eef-toggle-btn");
  toggles.forEach(function (btn) {
    btn.addEventListener("click", function () {
      toggles.forEach(function (b) { b.classList.remove("eef-active"); });
      btn.classList.add("eef-active");
    });
  });

  // ============ NAV HIDE/SHOW + STICKY CART ============
  var nav = document.getElementById("eef-nav");
  var sticky = document.getElementById("eef-sticky-cart");
  var lastY = 0;
  var ticking = false;

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        if (nav) {
          if (y > 100 && y > lastY) nav.classList.add("eef-hidden");
          else nav.classList.remove("eef-hidden");
          if (y > 20) nav.classList.add("eef-scrolled");
          else nav.classList.remove("eef-scrolled");
        }
        if (sticky) {
          if (y > 600) sticky.classList.add("eef-show");
          else sticky.classList.remove("eef-show");
        }
        lastY = y;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // ============ SHOPIFY DAWN CART DRAWER INTEGRATION (mirrors product-form.js) ============

  function getCartUi() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  function getCartAddUrl() {
    var cartAddPath =
      typeof routes !== "undefined" && routes.cart_add_url
        ? String(routes.cart_add_url)
        : "/cart/add";
    if (cartAddPath.startsWith("/") && cartAddPath.indexOf("cart") !== -1) {
      return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
    }
    return "/cart/add.js";
  }

  function parseQuantity(btn) {
    var q = parseInt(btn.getAttribute("data-quantity"), 10);
    if (!Number.isNaN(q) && q > 0) {
      return q;
    }
    return 1;
  }

  function fetchSectionHtmlForCart(cart, data, doRender) {
    if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
      doRender(data);
      return Promise.resolve();
    }
    var sectionIds = cart.getSectionsToRender().map(function (s) {
      return s.id;
    });
    return Promise.all(
      sectionIds.map(function (id) {
        return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
          return r.text();
        });
      })
    )
      .then(function (htmls) {
        var sections = {};
        sectionIds.forEach(function (id, i) {
          sections[id] = htmls[i];
        });
        doRender(Object.assign({}, data, { sections: sections }));
      })
      .catch(function () {
        doRender(data);
      });
  }

  document.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      if (btn.getAttribute("aria-disabled") === "true") {
        return;
      }

      var cart = getCartUi();
      var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
      var spRaw = btn.getAttribute("data-selling-plan") || "";
      var quantity = parseQuantity(btn);

      if (!vid || Number.isNaN(vid)) {
        console.warn("[feelawsm-funnel] Missing variant ID on ATC button");
        return;
      }

      var sellingPlanId = null;
      if (String(spRaw).trim() !== "") {
        var spNum = parseInt(spRaw, 10);
        if (!Number.isNaN(spNum)) {
          sellingPlanId = spNum;
        }
      }

      var item = { id: vid, quantity: quantity };
      if (sellingPlanId != null) {
        item.selling_plan = sellingPlanId;
      }

      var body = { items: [item] };
      if (cart) {
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
        if (sellingPlanId == null) {
          body.sections = cart.getSectionsToRender().map(function (section) {
            return section.id;
          });
          body.sections_url = window.location.pathname;
        }
      }

      var addUrl = getCartAddUrl();
      var bodyString = JSON.stringify(body);

      // Buttons with data-atc-keep-content="true" (like the hero price card)
      // keep their content intact; CSS uses [aria-busy] to overlay a loading label.
      var keepContent = btn.getAttribute("data-atc-keep-content") === "true";
      var previousHtml = btn.innerHTML;
      if (!keepContent) {
        btn.innerHTML = "";
        btn.appendChild(document.createTextNode("Adding…"));
      }
      btn.classList.add("eef-loading");
      btn.setAttribute("aria-busy", "true");
      btn.setAttribute("aria-disabled", "true");

      var cartAddPromise =
        sellingPlanId != null
          ? new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open("POST", addUrl, true);
              xhr.setRequestHeader("Content-Type", "application/json");
              xhr.setRequestHeader("Accept", "application/json");
              xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
              xhr.onload = function () {
                if (xhr.status < 200 || xhr.status >= 400) {
                  reject(new Error("Cart add failed: " + xhr.status));
                  return;
                }
                try {
                  resolve(JSON.parse(xhr.responseText));
                } catch (e) {
                  reject(e);
                }
              };
              xhr.onerror = function () {
                reject(new Error("Cart add network error"));
              };
              xhr.send(bodyString);
            })
          : fetch(addUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: bodyString,
            }).then(function (response) {
              if (!response.ok) {
                throw new Error("Cart add failed: " + response.status);
              }
              return response.json();
            });

      cartAddPromise
        .then(function (response) {
          if (response.status) {
            if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
              publish(window.PUB_SUB_EVENTS.cartError, {
                source: "feelawsm-electrolyt-essenz-funnel",
                productVariantId: String(vid),
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            var desc = (response.description || response.message || "Could not add to cart").toString();
            alert(desc);
            return;
          }

          if (!cart) {
            if (typeof routes !== "undefined" && routes.cart_url) {
              window.location.href = routes.cart_url;
            } else {
              window.location.href = "/cart";
            }
            return;
          }

          if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: "feelawsm-electrolyt-essenz-funnel",
              productVariantId: String(vid),
              cartData: response,
            });
          }
          window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

          var doRender = function (data) {
            cart.renderContents(data);
          };

          if (cart.classList && cart.classList.contains("is-empty")) {
            cart.classList.remove("is-empty");
          }

          return fetchSectionHtmlForCart(cart, response, doRender);
        })
        .catch(function (err) {
          console.warn("[feelawsm-funnel]", err);
          var msg = (err && err.message) || "Could not add to cart";
          alert(msg);
        })
        .finally(function () {
          if (!keepContent) {
            btn.innerHTML = previousHtml;
          }
          btn.classList.remove("eef-loading");
          btn.removeAttribute("aria-busy");
          btn.removeAttribute("aria-disabled");
        });
    });
  });
})();
